import { PropsWithChildren, createContext, useState } from "react";

interface StepsContextInterface {
    stepsX: number[];
    setSteps: (value: number[]) => void;
}

export const StepsManagerContext = createContext<StepsContextInterface>({
    stepsX: [],
    setSteps: () => {},
});

type StepsManagerProps = PropsWithChildren;

const StepsManager = ({ children }: StepsManagerProps) => {
    const [stepsX, setSteps] = useState<number[]>([]);

    return (
        <StepsManagerContext.Provider
            value={{
                setSteps,
                stepsX,
            }}
        >
            {children}
        </StepsManagerContext.Provider>
    );
};

export default StepsManager;
